/**
 * Ajax filtering for the Forms and Applications landing page
 */
(function (window, document, $, undefined) {
	'use strict';

	window.formsAndApplicationsFilter = {

		/**
		 * Initialize script behavior.
		 *
		 * @since 1.0.0
		 */
		init: function () {
			formsAndApplicationsFilter.initVars();
			formsAndApplicationsFilter.getQueryVars();
			formsAndApplicationsFilter.pageInit();
			formsAndApplicationsFilter.bind();
			formsAndApplicationsFilter.submit();
			formsAndApplicationsFilter.filterReset();
		},

		/**
		 * Setting and initializing all variables.
		 *
		 * @since 1.0.0
		 */
		initVars: function () {
			formsAndApplicationsFilter.$base_url = $(".page-template-document-library #base_url").val();
			formsAndApplicationsFilter.$xhrQueue = [];
			formsAndApplicationsFilter.$form_reset = false;
		},

		/**
		 * Get all of the select values for the query string
		 *
		 * @since 1.0.0
		 */
		getQueryVars: function () {
			// (re)set the object
			formsAndApplicationsFilter.$query_vars = {};

			// Get non-checkbox values
			$('.filter-select').each(
				function () {
					// If a form field ins't empty add it to the array
					if ($(this).val() !== '') {
						formsAndApplicationsFilter.$query_vars[$(this).data('arg-type')] = $(this).val();
					}
				}
			);

			// Special handling for tags checkboxes
			// Grab all the values and comma separate them
            // We use 00 as the delimiter to handle weird encoding decoding scenarios
			formsAndApplicationsFilter.$tagValues = $('.page-template-document-library .tag-checkbox:checked').map(
				function () {
					return $(this).val();
				}
			).get().join("00");

			if (formsAndApplicationsFilter.$tagValues != '') {
				formsAndApplicationsFilter.$query_vars['tags'] = formsAndApplicationsFilter.$tagValues;
			}
		},

		/**
		 * Build the URL we need to call
		 *
		 * @since 1.0.0
		 */
		buildTheURL: function () {
			// Build the query string
			formsAndApplicationsFilter.getQueryVars();

			// If empty use the base URL
			if ($.isEmptyObject(formsAndApplicationsFilter.$query_vars)) {
				return formsAndApplicationsFilter.$base_url;
			}

			var query_vars = '?';
			Object.keys( formsAndApplicationsFilter.$query_vars ).forEach(
				function (key) {
					var value = formsAndApplicationsFilter.$query_vars[key];
					query_vars += key + '=' + value.replace(/\s/g, "+") + '&';
				}
			);
			return formsAndApplicationsFilter.$base_url + query_vars.replace(/&\s*$/, "");
		},

		/**
		 * Put everything together and make the call
		 *
		 * @since 1.0.0
		 */
		makeTheCall: function (url) {

			// Kill all active xhr requests before starting a new one.
			var i = 0;
			while (formsAndApplicationsFilter.xhrAbort() && i < formsAndApplicationsFilter.$xhrQueue.length) {
				if (formsAndApplicationsFilter.$xhrQueue[i]) {
					formsAndApplicationsFilter.$xhrQueue[i].abort();
				}
				i++;
			}

			// Make the call
			formsAndApplicationsFilter.filterAjaxCall(url);
		},

		/**
		 * Call the formatted URL
		 *
		 * @since 1.0.0
		 */
		filterAjaxCall: function (url) {
			// Show the 'loading' overlay
			$('.loading-overlay').show();

			// Make the call
			$(".page-template-document-library #ajax-archive").load(
				url + ' #ajax-archive', function (response, status, xhr) {
					if (status == "success") {
						// Hide the overlay on success
						$('.loading-overlay').hide();
						// Push the browser history state
						var stateObj = { state: "ready" };
						var page_title = $(document).find("title").text();
						history.pushState(stateObj, page_title, url);
					}
				}
			);
		},

		/**
		 * Abort all active xhr requests before making a new one.
		 *
		 * @since 1.0.0
		 */
		xhrAbort: function () {
			$(document).ajaxSend(
				function (event, jqxhr, settings) {
					formsAndApplicationsFilter.$xhrQueue.push(jqxhr); //alert( settings.url );
				}
			);
			$(document).ajaxComplete(
				function (event, jqxhr, settings) {
					var i;
					if ((i = $.inArray(jqxhr, formsAndApplicationsFilter.$xhrQueue)) > -1) {
						formsAndApplicationsFilter.$xhrQueue.splice(i, 1); //alert( "C:" + settings.url );
					}
				}
			);
			return formsAndApplicationsFilter.$xhrQueue.length;
		},

		/**
		 * Reset the filter
		 *
		 * @since 1.0.0
		 */
		filterReset: function () {
			$(".page-template-document-library #filter-reset").click(
				function (e) {
					e.preventDefault();

					if ( encodeURI(window.location.href) !== formsAndApplicationsFilter.$base_url) {
						// Reset the filter form to empty
						$('#forms-and-applications-filter, #forms-and-applications-document-categories-filter').trigger('reset');
						$('#forms-and-applications-document-categories-filter input:checkbox').removeAttr('checked');
						$('#forms-and-applications-document-categories-filter .jh-checkbox').removeClass('jh-checkbox--checked');

						// Make the call
						formsAndApplicationsFilter.makeTheCall(formsAndApplicationsFilter.$base_url);
					}
				}
			);
		},

		/**
		 * Bind all event listeners.
		 *
		 * @since 1.0.0
		 */
		bind: function () {

			$("#forms-and-applications-filter, #forms-and-applications-document-categories-filter").bind(
				// Debounce for 1 second before triggering
				"keyup change", jh_custom.debounce( 
					function() {
				  		formsAndApplicationsFilter.makeTheCall(formsAndApplicationsFilter.buildTheURL()),
						1000
					}
				)
			);
		},

		/**
		 * Submit Button.
		 *
		 * @since 1.0.0
		 */
		submit: function () {
			$("#forms-and-applications-filter").submit(
				function (e) {
					e.preventDefault();
					formsAndApplicationsFilter.makeTheCall(formsAndApplicationsFilter.buildTheURL());
				});

		},

		/**
		 *  Adjust the filter on initial page load if coming from another link and not ajax
		 *
		 * @since 1.0.0
		 */
		pageInit: function () {

			// If there are any query vars at all, scroll down to the results
			if ($.isEmptyObject(formsAndApplicationsFilter.$query_vars)) {
				// No empty actions at this time
			} else {
				// Wait until doc ready to scroll to avoid jitter
				$(document).ready(
					function () {
						$.scrollTo('.page-template-document-library #ajax-archive', 500, { offset: -75 });
					}
				);
			}
		},

	};

	formsAndApplicationsFilter.init();

})(window, document, jQuery);
